module.exports = __webpack_public_path__ + "static/media/KotoPumpFinal.4ca28f11.png";